module.exports = __webpack_public_path__ + "img/product-center-normaeweb.0306b569.png";